import { ImportJobStatus } from '@common/api';

export type ImportFilter = {
    nameSearch: string;
    statuses: ImportJobStatus[];
    labelNames: string[];
};

export const INITIAL_FILTER: ImportFilter = {
    nameSearch: '',
    statuses: [ImportJobStatus.CREATED, ImportJobStatus.COMMITED, ImportJobStatus.REVERTED],
    labelNames: [],
};
